export default __webpack_public_path__ + "static/media/white-right-arrow.1c6444e4.svg";